export const FILE_STATUS = [
  {
    id: null,
    label: "Väntar på utskrift",
    color: "warning",
  },
  {
    id: -1,
    label: "Ej utskrift",
    color: "primary",
  },
  {
    id: 0,
    label: "Utskriven",
    color: "success",
  },
];
